import type { ReactNode } from 'react'
import styles from './WorkspaceSignup.module.css'
import { IconButton } from '@/components/IconButton'
import { type ConfigurerView } from './WorkspaceSignupViewModel'

export interface WorkspaceSignupProps {
  configurerView: ConfigurerView
  onBack: () => unknown
  children: ReactNode
}

export function WorkspaceSignup({
  configurerView,
  onBack,
  children,
}: WorkspaceSignupProps) {
  return (
    <div className={styles.configurer}>
      <div className={styles.titlebar}>
        {configurerView !== 'Register' && (
          <IconButton name="back" label="Back" onPress={() => onBack()} />
        )}
        <h4>
          Workspace {configurerView === 'Register' && 'Registration'}
          {configurerView === 'Search' && 'Search'}
        </h4>
      </div>
      {children}
    </div>
  )
}
